import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

const CategoryBox = ({id, quantity}) => {

  const colors = [
    "linear-gradient(0.25turn,#008a3e, #006b3e)", 
    "linear-gradient(0.25turn,#640ccf, #640cbf)", 
    "linear-gradient(0.25turn,#f02dfd, #fd2dc8)",
    "linear-gradient(0.25turn,#f5b902, #d6a100)",
  ]

  return (
    <div 
      style={{ minWidth:"200px", maxWidth: "260px", flexGrow: "1", background:`turquoise`}} 
      className="rounded m-2 text-light p-4 d-flex flex-column"
    >
      <p className='fs-2'>Category {id}</p>
      <div style={{padding:"1px"}} className="bg-light w-100 mb-3"></div>
      <p>Inventory: <span className='fw-bold'>{quantity}</span></p>
      <p className=''>Added Last Quarter: <span className='fw-bold'>{Math.ceil(quantity /20) + Math.ceil(Math.random()*20)}</span></p>
      <div style={{padding:"1px"}} className="bg-light w-100 mb-3"></div>
      <div className='d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon className='fs-2' icon={faClock} /> 
        <p>March 17 2.15 am</p>

      </div>
      
    </div>
  )
}

export default CategoryBox